<!--
 * @Description: 合作伙伴详情
 * @Author: cxh
 * @Date: 2022-05-24 15:19:34
 * @LastEditTime: 2023-03-13 16:44:12
 * @LastEditors: cxh
-->
<template>
  <dc-layout-main>
    <dc-layout-content :loading="loading">
      <CosViewContent
        header
        :title="data?.customerInfo?.customerName"
        :sellerName="data?.customerInfo?.sellerName"
        :customLabel="t('custom.customerNumber')"
        :customValue="data?.customerInfo?.customerNumber"
      >
        <a-tabs @change="changeTabs" v-model:activeKey="activeKey">
          <a-tab-pane key="base" :tab="t('common.baseTabs')">
            <baseMessage :disabled="true" formItemView :data="data" :permissionPage="permissionBasic" />
          </a-tab-pane>
          <a-tab-pane key="contact" :tab="t('common.concatTabs')">
            <TabsContacts
              ref="contactsRef"
              appId="cos_ofbu"
              :contactRefId="route.query.cosId"
              :permissionPage="permissionConcat"
            />
          </a-tab-pane>
          <a-tab-pane key="3" :tab="t('common.followTabs')">
            <TabsClueCosFollowUp
              appId="cos_ofbu"
              :showFooter="true"
              :followRefId="route.query.cosId"
              :permissionPage="permissionFollow"
            />
          </a-tab-pane>
          <a-tab-pane key="4" :tab="t('common.bussiessTabs')">
            <tabsBusiness :permissionPage="permissionBuss" />
          </a-tab-pane>
          <a-tab-pane key="5" :tab="t('common.contractTabs')">
            <tabsContract />
          </a-tab-pane>
          <a-tab-pane key="6" :tab="t('common.conversionTabs')">
            <tabsConversion appId="cos_ofbu" :resourceId="route.query.cosId" />
          </a-tab-pane>
          <a-tab-pane key="operationLog" :tab="t('common.operationLogTabs')">
            <TabsOperationLog
              ref="operationLogRef"
              tableId="DcCosOFbuPotentialOperationLog"
              appId="cos_ofbu"
              :resourceId="route.query.cosId"
            />
          </a-tab-pane>
          <a-tab-pane key="8" :tab="t('common.arkCodeTabs')">
            <tabsCode />
          </a-tab-pane>
          <a-tab-pane key="9" :tab="t('common.subjectTabs')">
            <tabsMainBody />
          </a-tab-pane>
        </a-tabs>
      </CosViewContent>
      <ViewFooterBtn
        :permissionPage="permissionBasic"
        @success="footerSuccess"
        :loading="loading"
        type="potential"
        :workCode="data?.customerInfo?.seller"
      />
    </dc-layout-content>
  </dc-layout-main>
</template>
<script lang="ts" setup>
import { onMounted, ref } from 'vue'
import TabsOperationLog from '@/components/TabsOperationLog/index.vue'
import TabsConversion from '@/components/TabsConversion'
import TabsClueCosFollowUp from '@/components/TabsClueCosFollowUp'
import TabsContacts from '@/components/TabsContacts/index.vue'
import baseMessage from '@/views/overseasSales/customerCenter/components/baseMessage.vue'
import ViewFooterBtn from '@/views/overseasSales/customerCenter/components/viewFooterBtn.vue'
import tabsContract from '@/views/overseasSales/customerCenter/components/tabsContract.vue'
import tabsCode from '@/views/overseasSales/customerCenter/components/tabsCode.vue'
import tabsBusiness from '@/views/overseasSales/customerCenter/components/tabsBusiness.vue'
import tabsMainBody from '@/views/overseasSales/customerCenter/components/tabsMainBody.vue'
import { potentialDetail } from '@/api/overseasSales/customerCenter'
import { useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
const route = useRoute()
const data = ref({})
const operationLogRef = ref()
const contactsRef = ref()
const loading = ref(false)
const activeKey = ref('base')
// 获取详情
const fetch = () => {
  if (route.query.cosId) {
    loading.value = true
    potentialDetail(route.query.cosId)
      .then((res) => {
        if (res.data.business && res.data.business.businessType && res.data.business.businessType?.length > 0) {
          res.data.business.businessTypeSelect = res.data.business.businessType[0]
        }
        data.value = res.data
      })
      .finally(() => {
        loading.value = false
      })
  }
}
// 标签页切换
const changeTabs = (v: string) => {
  if (v === 'base') {
    fetch()
  } else if (v === 'operationLog') {
    operationLogRef.value?.fetch()
  }
}
const footerSuccess = (tag: 'base' | 'contact') => {
  if (tag === 'base') {
    fetch()
  } else if (tag === 'contact') {
    // 更新联系人或者操作日志
    if (activeKey.value === 'contact') {
      contactsRef.value?.refresh()
    } else if (activeKey.value === 'operationLog') {
      operationLogRef.value?.fetch()
    }
  }
}
onMounted(() => {
  fetch()
})
const permissionBasic = {
  transfer: 'ofbu_potential_transfer_btn',
  follow_add: 'ofbu_potential_follow_add_btn',
  visitor_add: 'ofbu_potential_visitor_add_btn',
  edit: 'ofbu_potential_edit_btn',
  buss_add: 'ofbu_potential_buss_add_btn',
  concat_add: 'ofbu_potential_concat_add_btn'
}
const permissionFollow = {
  edit: 'ofbu_potential_follow_edit_btn',
  del: 'ofbu_potential_follow_del_btn',
  comment: 'ofbu_potential_follow_comment_btn'
}
const permissionBuss = {
  edit: 'ofbu_potential_buss_edit_btn',
  del: 'ofbu_potential_buss_del_btn'
}
const permissionConcat = {
  edit: 'ofbu_potential_concat_edit_btn',
  del: 'ofbu_potential_concat_del_btn'
}
</script>
<script lang="ts">
export default {
  name: 'FbuPotentialView'
}
</script>
